// commaFunction.js - Updated version
const muiComma = (value) => {
  if (value === null || value === undefined || value === '') {
    return '0'; // or return '' if you prefer empty string
  }
  
  // Convert to string and handle commas
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default muiComma;